import { manage2FASettings } from 'common/constants/permissions';

function canManageMFASettings(permissions) {
    return !!permissions[manage2FASettings];
}

export default {
    canManageMFASettings
};
